"use strict";

exports.__esModule = true;
exports.default = updateSlidesOffset;

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/cjs/components/core/update/updateSlidesOffset.js
// module id = 52
// module chunks = 0